import ModalDrawerSwitcher from './ModalDrawerSwitcher';

export default ModalDrawerSwitcher;